import ListRenameModal from "../../components/modals/ListRenameModal/ListRenameModal";
import withListRenameModalTracking from "./withListRenameModalTracking";

const ListRenameModalTracked = withListRenameModalTracking(ListRenameModal);

export default ListRenameModalTracked;
